import { PROJECT_TASKS_CRUD_ACTION_CONSTANTS as CRUD_ACTION_CONSTANTS } from '../actions/project_tasks_actions';
import { standardInitialStateGenerator, standardReducerGenerator } from './standard_reducer_utils';

const initialState: any = standardInitialStateGenerator([
	'projectTasksIndex',
	'DELIVERABLE_TASKS',
	'PROJECT_TASKS',
]);
export default standardReducerGenerator(CRUD_ACTION_CONSTANTS, initialState);
